export default function TimesheetProgressCard({ score, goalLabel, goalValue, progress }) {
  return (
    <article className="overflow-hidden rounded-lg bg-surface-container-lowest p-6">
      <div className="mb-6 flex items-start justify-between">
        <div>
          <h3 className="mb-1 text-[11px] font-semibold uppercase tracking-wider text-on-surface-variant">
            Timesheet Progress
          </h3>
          <p className="text-5xl font-black text-primary">{score}%</p>
        </div>
        <div className="rounded-xl bg-primary/10 p-3 text-primary">
          <span className="material-symbols-outlined text-3xl">schedule</span>
        </div>
      </div>

      <div>
        <div className="mb-2 flex items-center justify-between text-[11px] font-bold text-on-surface-variant">
          <span>{goalLabel}</span>
          <span>{goalValue}</span>
        </div>
        <div className="h-2 w-full overflow-hidden rounded-full bg-surface-variant">
          <span
            className="block h-full rounded-full bg-primary transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </article>
  )
}
